var _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvantage4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 63,
    width: 50,
    height: 6,
    rx: 1,
    fill: "#1A2027"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 50,
    height: 6,
    rx: 1,
    fill: "#1A2027"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 45.52C28.4787 45.52 33.52 40.4787 33.52 34.26C33.52 28.0413 28.4787 23 22.26 23C16.0413 23 11 28.0413 11 34.26C11 40.4787 16.0413 45.52 22.26 45.52Z",
    fill: "#007FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.26 77.52C28.4787 77.52 33.52 72.4787 33.52 66.26C33.52 60.0413 28.4787 55 22.26 55C16.0413 55 11 60.0413 11 66.26C11 72.4787 16.0413 77.52 22.26 77.52Z",
    fill: "#007FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7698 40.2101H20.6099C20.4414 40.2147 20.2739 40.1832 20.1187 40.1177C19.9634 40.0521 19.824 39.9541 19.7098 39.8301L15.6099 35.4301C15.424 35.1936 15.3338 34.8958 15.3571 34.5959C15.3804 34.296 15.5155 34.0158 15.7356 33.8108C15.9558 33.6057 16.2448 33.4909 16.5457 33.4889C16.8465 33.4869 17.1371 33.598 17.3599 33.8001L20.5598 37.2201L27.1298 29.0701C27.3429 28.8337 27.6399 28.6898 27.9575 28.6693C28.2751 28.6487 28.5881 28.7531 28.8298 28.9601C28.9489 29.0633 29.0463 29.1891 29.1164 29.3302C29.1864 29.4713 29.2278 29.6249 29.238 29.7822C29.2482 29.9394 29.2272 30.097 29.176 30.246C29.1248 30.395 29.0445 30.5324 28.9398 30.6501L21.4999 39.8001C21.3142 40.0207 21.0548 40.1664 20.7698 40.2101V40.2101Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7698 72.2101H20.6099C20.4414 72.2147 20.2739 72.1832 20.1187 72.1177C19.9634 72.0521 19.824 71.9541 19.7098 71.8301L15.6099 67.4301C15.424 67.1936 15.3338 66.8958 15.3571 66.5959C15.3804 66.296 15.5155 66.0158 15.7356 65.8108C15.9558 65.6057 16.2448 65.4909 16.5457 65.4889C16.8465 65.4869 17.1371 65.598 17.3599 65.8001L20.5598 69.2201L27.1298 61.0701C27.3429 60.8337 27.6399 60.6898 27.9575 60.6693C28.2751 60.6487 28.5881 60.7531 28.8298 60.9601C28.9489 61.0633 29.0463 61.1891 29.1164 61.3302C29.1864 61.4713 29.2278 61.6249 29.238 61.7822C29.2482 61.9394 29.2272 62.097 29.176 62.246C29.1248 62.395 29.0445 62.5324 28.9398 62.6501L21.4999 71.8001C21.3142 72.0207 21.0548 72.1664 20.7698 72.2101V72.2101Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 64,
    width: 48,
    height: 4,
    fill: "#F6F6F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 48,
    height: 4,
    fill: "#F6F6F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage4);
export default __webpack_public_path__ + "static/media/advantage-4.cb4fa85d0c4ea1081eaffb8fbf7ba07b.svg";
export { ForwardRef as ReactComponent };